import { render, staticRenderFns } from "./propertyDetail.vue?vue&type=template&id=6ee17e3a&scoped=true&"
import script from "./propertyDetail.vue?vue&type=script&lang=js&"
export * from "./propertyDetail.vue?vue&type=script&lang=js&"
import style0 from "./propertyDetail.vue?vue&type=style&index=0&id=6ee17e3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee17e3a",
  null
  
)

export default component.exports